import { toURLSearchParams } from '@wix/sdk-runtime/rest-modules';
import { resolveUrl } from '@wix/sdk-runtime/rest-modules';
import { ResolveUrlOpts } from '@wix/sdk-runtime/rest-modules';
import { RequestOptionsFactory } from '@wix/sdk-types';

function resolveComWixFedSettingsAppSettingsServiceUrl(
  opts: Omit<ResolveUrlOpts, 'domainToMappings'>
) {
  const domainToMappings = {
    'www._base_domain_': [
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
      {
        srcPath: '/_api/app-settings-service/v1/settings/components',
        destPath: '/api/v1/settings/components',
      },
    ],
    'api._api_base_domain_': [
      {
        srcPath: '/app-settings-service',
        destPath: '',
      },
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
    ],
    'bo._base_domain_': [
      {
        srcPath: '/app-settings-service',
        destPath: '/private/api',
      },
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
      {
        srcPath: '/dev/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    'wixbo.ai': [
      {
        srcPath: '/app-settings-service',
        destPath: '/private/api',
      },
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
      {
        srcPath: '/dev/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    'wix-bo.com': [
      {
        srcPath: '/app-settings-service',
        destPath: '/private/api',
      },
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
      {
        srcPath: '/dev/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    _: [
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
      {
        srcPath: '/_api/app-settings-service/v1/settings/components',
        destPath: '/api/v1/settings/components',
      },
      {
        srcPath: '/_api/app-settings-service/v1/settings/instances',
        destPath: '/api/v1/settings/instances',
      },
    ],
    'editor._base_domain_': [
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    'blocks._base_domain_': [
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    'create.editorx': [
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    '*.dev.wix-code.com': [
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
    ],
    'progallery._base_domain_': [
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    'ecom._base_domain_': [
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    'bookings.wixapps.net': [
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
    ],
    'scheduler._base_domain_': [
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    'manage._base_domain_': [
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    'progallery.wixapps.net': [
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    'support._base_domain_': [
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    'social-blog._base_domain_': [
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
    ],
    'editor.wixapps.net': [
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    'dev._base_domain_': [
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    'www.wixapis.com': [
      {
        srcPath: '/settings',
        destPath: '/api',
      },
      {
        srcPath: '/user-preferences',
        destPath: '/api/v1/userPreferences',
      },
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    'addresses.wixapps.net': [
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
    ],
    'vibe._base_domain_': [
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    'manage.base44.com': [
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    'payments.base44.com': [
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
    'platform.rise.ai': [
      {
        srcPath: '/_api/app-settings-service',
        destPath: '/api',
      },
      {
        srcPath: '/_api/wix-user-preferences-webapp',
        destPath: '/api/v1/userPreferences',
      },
    ],
  };

  return resolveUrl(Object.assign(opts, { domainToMappings }));
}

const PACKAGE_NAME = '@wix/auto_sdk_app-settings_app-settings';

/** Set component settings by componentId */
export function setComponentSettings(
  payload: object
): RequestOptionsFactory<any> {
  function __setComponentSettings({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.app_settings.v1.settings',
      method: 'PATCH' as any,
      methodFqn: 'com.wix.fed.settings.AppSettingsService.SetComponentSettings',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixFedSettingsAppSettingsServiceUrl({
        protoPath: '/api/v1/settings/components/{componentId}',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __setComponentSettings;
}

/** Get component settings by componentId */
export function getComponentSettings(
  payload: object
): RequestOptionsFactory<any> {
  function __getComponentSettings({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.app_settings.v1.settings',
      method: 'GET' as any,
      methodFqn: 'com.wix.fed.settings.AppSettingsService.GetComponentSettings',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixFedSettingsAppSettingsServiceUrl({
        protoPath: '/api/v1/settings/components/{componentId}',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getComponentSettings;
}

/** Set global settings by instanceId (extracted from Authorization) */
export function setGlobalSettings(payload: object): RequestOptionsFactory<any> {
  function __setGlobalSettings({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.app_settings.v1.settings',
      method: 'PATCH' as any,
      methodFqn: 'com.wix.fed.settings.AppSettingsService.SetGlobalSettings',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixFedSettingsAppSettingsServiceUrl({
        protoPath: '/api/v1/settings/instances',
        data: payload,
        host,
      }),
      data: payload,
    };

    return metadata;
  }

  return __setGlobalSettings;
}

/** Get global settings by instanceId (extracted from Authorization) */
export function getGlobalSettings(payload: object): RequestOptionsFactory<any> {
  function __getGlobalSettings({ host }: any) {
    const metadata = {
      entityFqdn: 'wix.app_settings.v1.settings',
      method: 'GET' as any,
      methodFqn: 'com.wix.fed.settings.AppSettingsService.GetGlobalSettings',
      packageName: PACKAGE_NAME,
      migrationOptions: {
        optInTransformResponse: true,
      },
      url: resolveComWixFedSettingsAppSettingsServiceUrl({
        protoPath: '/api/v1/settings/instances',
        data: payload,
        host,
      }),
      params: toURLSearchParams(payload),
    };

    return metadata;
  }

  return __getGlobalSettings;
}
